import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& *::placeholder': {
        opacity: 1,
      },
      '& .MuiInputBase-root': {
        width: 'auto',
      },
    },
  }),
);

export default useStyles;
